<template>
  <div class="app flex-row align-items-center" id="formLogin">
    <div style="width: 100%;height: 100vh;">
      <CRow class="justify-content-center"
            style="height: 100%;margin: auto 0!important;background: url('../static/img/background-design.png');background-size: cover; background-repeat: no-repeat;">
        <CCol id="content-right" md="12" xl="4" style="margin:auto;">
          <div class="container">
            <CCard no-body style="background: rgb(71 118 223 / 18%);border: none!important;min-width: 400px;">
              <CCardBody>

                <CForm id="form-confirm-otp" v-on:submit.prevent>
                  <h2 style="text-align:center;margin-bottom: 20px;font-weight: bold; font-size: 1.65rem;"
                      class="form-fade-in-top">
                    Xác thực mã OTP
                  </h2>
                  <div class="form-fade-in-bottom">
                    <div class="mb-2" style="margin-top: 15px!important;">
                      <BaseInput :options="otpInput.options"
                                 :data="otpInput.data" class="input-wrapper"/>
                    </div>
                    <div class="mb-2" style="margin-top: 15px!important;">
                      <div class="countdown">
                        <div class="block">
                          <p class="digit"><i class="fa fa-clock-o"
                                              style="font-size: 17px;margin-right: 10px;"></i>&nbsp;&nbsp;{{
                              minutes | two_digits
                            }}</p>
                        </div>
                        <div class="block">
                          <p class="digit">:{{ seconds | two_digits }}</p>
                        </div>
                      </div>
                    </div>
                    <CRow>
                      <CCol cols="6" style="margin-top: 15px!important;">
                        <CButton :disabled="disableBtnVerifyOTP" class="px-12 ripple btn-primary"
                                 @click.prevent="submitVerifyOTP()"
                                 style="padding: 8px!important; height: 42px!important;border-radius: 2.5rem!important;
                                background: linear-gradient(to right, #6e50ff, #506bff, #0093ff)!important;
                                font-size: 1rem!important;font-weight: 400!important;text-transform: uppercase;border: unset">
                          Xác thực&nbsp;
                          <div class="ripple-effect" hidden></div>
                        </CButton>
                      </CCol>
                      <CCol cols="6" style="margin-top: 15px!important;">
                        <CButton class="px-12 ripple"
                                 @click.prevent="submitResendOTP()"
                                 style="padding: 8px!important; height: 42px!important;border-radius: 2.5rem!important;
                                background: linear-gradient(to right, #9d97bd, #999fc4, #b0c5d3)!important;
                                font-size: 1rem!important;font-weight: 400!important;text-transform: uppercase;border: unset">
                          Gửi lại mã&nbsp;
                          <div class="ripple-effect" hidden></div>
                        </CButton>
                      </CCol>
                    </CRow>
                  </div>
                  <div style="display: flex;justify-content: center;margin-bottom: 15px;"></div>
                </CForm>

              </CCardBody>
            </CCard>
          </div>
        </CCol>
      </CRow>
    </div>
    <BaseLoading :loading="loading.value"></BaseLoading>
  </div>
</template>
<script>
import Vue from "vue";
import BaseLoading from "../base/BaseFormLoading";
import BaseInput from "../base/BaseInput";

import {authLogin, authLogout} from "@/security/index";
import {ACCESS_TOKEN_NAME, TIME_OTP_EXPIRED, USER_NAME} from "@/constant";

Vue.filter('two_digits', (value) => {
  if (value < 0) {
    return '00';
  }
  if (value.toString().length <= 1) {
    return `0${value}`;
  }
  return value;
});

export default {
  name: "ConfirmOTP",
  components: {BaseInput, BaseLoading},
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success"
    },
    showErrorMsg: {
      type: "error",
      title: "Errors"
    },
    showWarningMsg: {
      type: "warn",
      title: "warn"
    }
  },
  mounted: function () {
    let that = this;
    setTimeout(function () {
      that.setUpRippleButton();
    }, 500);
    this.now = Math.trunc((new Date()).getTime() / 1000);
    this.interValCountdown();
    setTimeout(function () {
      that.$helper.setupInputNumber('confirm-otp');
      that.$el.querySelector(".confirm-otp").focus();
    }, 200);
    this.checkTimeExpOTP();
    // this.checkIntervalRedirectLogin();
  },
  created: function () {
    this.checkTimeRedirectLogin();
  },
  data: function () {
    let that = this;
    return {
      loading: {value: false},
      now: '',
      otpInterVal: '',
      disableBtnVerifyOTP: false,
      timeExpOTP: localStorage.getItem(TIME_OTP_EXPIRED) || '',
      intervalRedirectLogin: '',

      otpInput: {
        options: {
          type: 'text',
          placeholder: "Mã OTP",
          maxlength: 6,
          addInputClasses: "confirm-otp",
        },
        data: {
          name: "otp",
          model: "",
          updateCallback: function () {
            that.submitVerifyOTP();
          },
          validator: {
            isValid: true,
            errorMessage: "",
            valid: function () {
              let value = that.otpInput.data.model;
              if (value === "") {
                this.isValid = false;
                this.errorMessage = "Mã xác thực OTP không được để trống";
                that.$el.querySelector(".confirm-otp").focus();
              } else if (value.length < 6) {
                this.isValid = false;
                this.errorMessage = "Mã xác thực OTP gồm 6 chữ số";
                that.$el.querySelector(".confirm-otp").focus();
              } else {
                this.isValid = true;
                this.errorMessage = "";
              }
              return this.isValid;
            }
          }
        }
      },
    };
  },
  computed: {
    dateInMilliseconds() {
      let time = new Date(this.timeExpOTP * 1);
      return Math.trunc(Date.parse(this.$helper.formatDateYYYYMMDDHHMMSS(time)) / 1000)
    },
    seconds() {
      return (this.dateInMilliseconds - this.now) % 60;
    },
    minutes() {
      return Math.trunc((this.dateInMilliseconds - this.now) / 60);
    },
  },
  watch: {
    'now': function (value) {
      let timeExp = localStorage.getItem(TIME_OTP_EXPIRED);
      let dateExp = new Date(timeExp * 1);
      if (dateExp <= new Date(value)) {
        this.disableBtnVerifyOTP = true;
        clearInterval(this.otpInterVal);
      }
    },
  },
  methods: {
    checkTimeRedirectLogin() {
      let timeExp = localStorage.getItem(TIME_OTP_EXPIRED);
      if (localStorage.getItem(ACCESS_TOKEN_NAME)) {
        this.$router.push({path: '/dashboard.html'});
      } else {
        if (timeExp) {
          let timeRedirect = this.$helper.plusDatetime(new Date(timeExp * 1), 2, 'm');
          if (timeRedirect <= new Date()) {
            authLogout();
          }
        } else {
          authLogout();
        }
      }
    },
    interValCountdown() {
      this.otpInterVal = window.setInterval(() => {
        this.now = Math.trunc((new Date()).getTime() / 1000);
      }, 1000);
    },
    checkTimeExpOTP() {
      let timeExp = localStorage.getItem(TIME_OTP_EXPIRED);
      if (timeExp && timeExp != undefined) {
        let dateExp = new Date(timeExp * 1);
        if (dateExp <= new Date()) {
          this.disableBtnVerifyOTP = true;
        }
      }
    },
    setUpRippleButton: function () {
      $(".ripple").on("click", function (event) {
        event.preventDefault();
        let $div = $("<div/>"),
          btnOffset = $(this).offset(),
          xPos = event.pageX - btnOffset.left,
          yPos = event.pageY - btnOffset.top;
        $div.addClass("ripple-effect");
        let $ripple = $(".ripple-effect");
        $div
          .css({
            top: yPos - $ripple.height() / 2,
            left: xPos - $ripple.width() / 2
          })
          .appendTo($(this));
        window.setTimeout(function () {
          $div.remove();
        }, 1500);
      });
    },
    submitVerifyOTP: function () {
      let that = this;
      if (!this.otpInput.data.validator.valid()) {
        return;
      }
      that.$helper.loadDataSource({
        loading: that.loading,
        url: "/users/verify-otp",
        isJsonContentType: false,
        dataSubmit: function () {
          return {
            username: localStorage.getItem(USER_NAME),
            otp: that.otpInput.data.model,
          };
        },
        successCallback: function (response) {
          if (!that.$helper.validResponse(that.$router, response.data) && response.data.returnCode !== 3) {
            that.showErrorMsg({message: that.$helper.getStringError(response.data.data)});
            that.$helper.setupErrorModel(response.data.data, that.$data);
            that.$el.querySelector(".confirm-otp").focus();
          } else {
            const {data} = response.data;
            localStorage.removeItem(TIME_OTP_EXPIRED);
            authLogin(data.access_token, data.refresh_token, data.expires_in, data.authorities, data.username, data.fullName, data.id, JSON.stringify(data.systems), data.lastUpdatePassword);
          }
        },
        errorCallback: function (error) {
          that.$helper.handleError(that.$router, error);
        }
      });
    },
    submitResendOTP: function () {
      let that = this;
      this.otpInput.data.model = '';
      that.$helper.loadDataSource({
        loading: that.loading,
        url: "/users/resend-otp",
        isJsonContentType: false,
        dataSubmit: function () {
          return {
            username: localStorage.getItem(USER_NAME),
          };
        },
        successCallback: function (response) {
          if (!that.$helper.validResponse(that.$router, response.data)) {
            that.showErrorMsg({message: that.$helper.getStringError(response.data.data)});
          } else {
            that.now = Math.trunc((new Date()).getTime() / 1000);
            that.timeExpOTP = response.data.data;
            that.interValCountdown();
            localStorage.setItem(TIME_OTP_EXPIRED, response.data.data);
            that.disableBtnVerifyOTP = false;
            that.showSuccessMsg({message: "Mã xác thực OTP đã được gửi lại vào email. Vui lòng kiểm tra lại."})
            that.$el.querySelector(".confirm-otp").focus();
          }
        },
        errorCallback: function (error) {
          that.$helper.handleError(that.$router, error);
        }
      });
    },
  },
  destroyed() {
    clearInterval(this.intervalRedirectLogin);
  }
};
</script>

<style>
#formLogin .input-wrapper > div > input {
  height: 42px !important;
}

#formLogin .loading-wrapper {
  background-color: rgba(2, 2, 2, 0.31);
}

.confirm-otp {
  text-align: center;
  font-weight: bold;
  font-size: 20px;
  letter-spacing: 3px;
}
</style>
<style scoped>
.countdown {
  display: flex;
  justify-content: center;
}

.block {
  display: flex;
  flex-direction: column;
}

.digit {
  font-size: 30px;
  font-weight: 100;
  font-family: 'Roboto', serif;
  text-align: center;
  display: inline-flex;
  align-items: center;
}

.btn.btn-action-primary.btn-primary, .btn.btn-action-primary.btn-primary:hover {
  border: none !important;
}

.group-button-special {
  margin-top: 10px;
  text-align: center;
  display: flex;
  justify-content: center;
}

.btn-special-google,
.btn-special-facebook {
  border: 1px solid #aaa;
  margin-right: 8px;
  width: 40%;
  font-size: 17px;
  padding-left: 16px;
  padding-right: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.btn-special-google svg,
.btn-special-facebook svg {
  margin-right: 5px !important;
}

.btn-special-google:hover {
  border-color: #ff8500;
  color: #ff8500;
}

.btn-special-facebook:hover {
  border-color: #0064ff;
  color: #1d70ff;
}

#register {
  margin-top: 15px;
  text-align: center;
}

#login:hover {
  background: rgba(13, 175, 223, 1) !important;
}

.mb-3 {
  margin-bottom: 0px !important;
  margin-top: 10px !important;
}

fieldset {
  border: 1px solid #ccc;
  padding: 15px;
  max-width: 345px;
  background-color: #fff;
  border-radius: 5px;
}

section {
  padding: 0 15px;
}

@media (max-width: 350px) {
  .btn-special-google[data-v-07b13bd8],
  .btn-special-facebook[data-v-07b13bd8] {
    width: unset !important;
  }

  .container {
    padding: 0px !important;
  }

  #content-left {
    width: 0;
    height: 0;
  }

  #forget {
    width: 50% !important;
  }
}

@media (min-width: 350px) and (max-width: 575px) {
  .container {
    padding: 0px !important;
  }

  #content-left {
    width: 0;
    height: 0;
  }
}

@media (min-width: 576px) and (max-width: 665px) {
  .btn-special-google[data-v-07b13bd8],
  .btn-special-facebook[data-v-07b13bd8] {
    font-size: 13px;
  }

  .container {
    padding: 0px !important;
  }

  #content-left {
    width: 0;
    height: 0;
  }

  #content-right {
    padding-left: 0px;
    padding-right: 0;
  }
}

@media (min-width: 666px) and (max-width: 767px) {
  .btn-special-google[data-v-07b13bd8],
  .btn-special-facebook[data-v-07b13bd8] {
    font-size: 13px;
  }

  .container {
    padding: 0px !important;
  }

  #content-left {
    width: 0;
    height: 0;
  }

  #content-right {
    padding-left: 0px;
    padding-right: 0;
  }
}

@media (min-width: 768px) and (max-width: 1100px) {
  .btn-special-google[data-v-07b13bd8],
  .btn-special-facebook[data-v-07b13bd8] {
    font-size: 13px;
  }
}

@media (min-width: 1101px) and (max-width: 1225px) {
  .btn-special-google[data-v-07b13bd8],
  .btn-special-facebook[data-v-07b13bd8] {
    font-size: 16px;
  }
}
</style>
